/**
    * @description      : 
    * @author           : Saif
    * @group            : 
    * @created          : 25/10/2023 - 02:34:11
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 25/10/2023
    * - Author          : Saif
    * - Modification    : 
**/
import { useState, useEffect, useContext } from "react";
import { Link, Navigate } from "react-router-dom";
import axios from "axios";

import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faEllipsisV,
  faEye,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

import { DashboardLayout } from "../../Layout/DashboardLayout";

import CustomTable from "./../../Components/CustomTable";
import { placeholderImage } from "../../Assets/images";

import "./style.css";
import { questionModal, successModal } from "../../Components/CustomModal";
import CustomFilters from "../../Components/CustomFilters";
import BASEURL from "../../Config/global";
import CustomPagination from "../../Components/CustomPagination";
import { disabledButtonByPermission } from "../../Components/Permissions";
import { PermissionsContext } from "../../Layout/PermissionContext";
import { deleteRequest } from "../../Util/requests";

const SpecialManagement = () => {
  const [data, setData] = useState([]);
  const { permissions } = useContext(PermissionsContext)

  const [enteries, setEnteries] = useState(10);
  const [offset, setOffset] = useState(0);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [filterSearchValue, setFilterSearchValue] = useState("");
  const [sort, setSort] = useState("all");
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("english");


  useEffect(() => {
    document.title = "Relax Scofa | Special Management";
  }, []);
  const modulesWisePermission = (condition) => {
    if (!permissions) {
      return 'd-none'
    }
    return disabledButtonByPermission(permissions, condition)
  }
  useEffect(() => {
    async function fetchData() {
      try {
        const languageParam = selectedLanguage === "spanish" ? "&language=spanish" : "";
        const response = await axios.get(
          `${BASEURL}/api/user/specials?limit=${enteries}&offset=${offset}&start_date=${dateFrom}&end_date=${dateTo}&search=${filterSearchValue}${languageParam}`
        );
        if (response.data.error != true) {
          console.log(response);
          setData(response.data.data);
          setTotalCount(response.data.count);
        } else {
          console.log(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, [enteries, filterSearchValue, dateTo, selectedLanguage]);

  const deleteArticle = async (id) => {
    setLoader(true)
    try {
      const response = await deleteRequest(`/api/user/specials/${id}`);
      if (response.data.error === false) {
        successModal.fire({
          text: "Special Deleted Successfully",
          confirmButtonText: "Continue",
        });
        setData(data.filter((item) => item.id !== id));
        setLoader(false);
        Navigate("/special-management");
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteArticleAction = (id, name) => {
    questionModal
      .fire({
        title: `Do you want to delete ${name} Article?`,
        confirmButtonText: "Yes",
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteArticle(id);
          successModal.fire({
            text: `${name} Article has been deleted`,
            confirmButtonText: "Continue",
          });
        }
      });
  };

  const articleHeader = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "title",
      title: "Title",
    },
    {
      key: "banner",
      title: "Banner Image",
    },
    {
      key: "link",
      title: "URL",
    },
    {
      key: "actions",
      title: "Actions",
    },
  ];

  const sortingValues = [
    {
      value: "all",
      text: "All",
    },
    {
      value: "status",
      text: "Status",
    },
    {
      value: "registered",
      text: "Registered Date",
    },
  ];

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-lg-8 mb-2">
              <h2 className="mainTitle">Specials </h2>
            </div>
            <div className="col-lg-4 text-end mb-2">
              <Link
                to={"/special-management/add-special"}
                className={`customButton primaryButton ${modulesWisePermission('can_add')}`}
              >
                Add Special
              </Link>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <CustomFilters
                enteries={enteries}
                totalCount={totalCount}
                entriesFilter={true}
                setEnteries={setEnteries}
                filterSearch={true}
                filterSearchValue={filterSearchValue}
                setFilterSearchValue={setFilterSearchValue}
                // dateFilter={true}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                // languageFilter
                // languageValue={selectedLanguage}
                // setLanguageValue={setSelectedLanguage}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12 special-table">
              <CustomTable headers={articleHeader}>
                <tbody>
                  {data &&
                    data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.title}</td>
                        <td className="text-capitalize">
                          <img
                            src={
                              item.banner
                                ? `${item.banner}`
                                : placeholderImage
                            }
                            alt="banner"
                            className="thumbnail"
                          />
                        </td>
                        <td>{item.link ? <a href={`${item.link}`} target="_blank" className="text-white"> View Link </a> : "No Link Available"}</td>
                        <td>
                          <Dropdown className="tableDropdown">
                            <Dropdown.Toggle
                              variant="transparent"
                              className="notButton classicToggle"
                            >
                              <FontAwesomeIcon icon={faEllipsisV} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              className="tableDropdownMenu"
                            >
                              {/* <Link
                                to={`/subscription-management/subscription-details/${item.id}`}
                                className="tableAction"
                              >
                                <FontAwesomeIcon
                                  icon={faEye}
                                  className="tableActionIcon"
                                />
                                View
                              </Link> */}
                              <Link
                                to={`/special-management/edit-special/${item.id}`}
                                className={`tableAction ${modulesWisePermission('can_edit')}`}
                              >
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  className="tableActionIcon"
                                />
                                Edit
                              </Link>
                              <button
                                className={`tableAction ${modulesWisePermission('can_delete')}`}
                                onClick={() => {
                                  deleteArticle(item.id, item.title);
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  className="tableActionIcon"
                                />
                                Delete
                              </button>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </CustomTable>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <CustomPagination
                enteries={data.length}
                totalCount={totalCount}
                setCurrentPage={setOffset}
                currentPage={offset}
              />
            </div>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
};
export default SpecialManagement;
